// extracted by mini-css-extract-plugin
export var footer = "_nq-0";
export var inherit = "_nq-1";
export var input = "_nq-2";
export var modalContent = "_nq-3";
export var quillEditor = "_nq-4";
export var subtitle = "_nq-5";